export default __webpack_public_path__ + "static/media/fundo_miolod.65da9ca9.png";